import { BREAKPOINTS } from "./../constants/constants";

type ScreenSizeType = keyof typeof BREAKPOINTS;

export function isScreenLessThan(size: ScreenSizeType): boolean {
  return BREAKPOINTS[size] < window.innerWidth;
}
